import { queryFilter } from 'utils/proptypes';
import base from './baseApi';

const { urls, methods, execute } = base();

type CreateProgramDto = {
   name: string;
   description?: string;
   index?: number | null;
   organizationId: string;
   isActive?: boolean;
};

type UpdateProgramDto = Partial<CreateProgramDto> & {
   id: string;
};

type ReorderProgramsDto = {
   id: string;
   index: string;
}[];

type UpsertProgramDto = {
   programId: string;
   organizationId: string;
};

type DeleteProgramDto = {
   id: string;
};

type GetProgramsQueryParams = queryFilter & {
   organizationId?: string;
};

const createProgram = (payload: CreateProgramDto) => {
   const method = methods.POST;
   const url = `${urls.program.create}`;

   return execute(method, url, { authorization: true }, payload);
};

const updateProgram = (payload: UpdateProgramDto) => {
   const method = methods.PATCH;
   const url = `${urls.program.update.replace(':id', payload.id)}`;

   return execute(method, url, { authorization: true }, payload);
};

const deleteProgram = (payload: DeleteProgramDto) => {
   const method = methods.DELETE;
   const url = `${urls.program.delete.replace(':id', payload.id)}`;

   return execute(method, url, { authorization: true });
};

const getPrograms = (params?: GetProgramsQueryParams) => {
   const header = {
      authorization: true,
   };

   const method = methods.GET;
   const url = `${urls.program.getAll}`;
   const response = execute(method, url, header, params);

   return response;
};

const getProgramById = (id: string) => {
   const method = methods.GET;
   const url = `${urls.program.getById.replace(':id', id)}`;

   return execute(method, url, { authorization: true });
};

const upsertUserProgram = (payload: UpsertProgramDto) => {
   const method = methods.PUT;
   const url = `${urls.userProgram.upsert.replace(':programId', payload.programId)}`;

   return execute(method, url, { authorization: true }, payload);
};

const reorderPrograms = (payload: { programs: ReorderProgramsDto }) => {
   const method = methods.POST;
   const url = urls.program.reorder;

   return execute(method, url, { authorization: true }, payload);
};

export { createProgram, deleteProgram, getProgramById, getPrograms, updateProgram, upsertUserProgram, reorderPrograms };

export type { CreateProgramDto, DeleteProgramDto, GetProgramsQueryParams, UpdateProgramDto };
